export default {
  props: {
    formAction: {
      type: String,
      required: true
    }
  }
}
